module.exports = __webpack_public_path__ + "static/media/hyperx-cloud-flight.9bc1491b.jpg";